import { useTranslation } from 'react-i18next';
import { kreditBetCreditorTypeLabel } from '@/domain/kredit-bet';
import { formatAmount } from '@/domain/player-balance';
import { cn } from '@/lib/cn';

export interface KreditBetSelectedTicketProps {
  ticketId: string;
  ticketType?: number | null;
  maxKredit: number;
  currency?: string;
  className?: string;
}

function withCurrency(amount: string, currency: string): string {
  return currency ? `${currency}${amount}` : amount;
}

/** Figma KreditBetSelectedTicket — type, ticket id, max kredit summary. */
export function KreditBetSelectedTicket({
  ticketId,
  ticketType,
  maxKredit,
  currency = '',
  className,
}: KreditBetSelectedTicketProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex w-full items-center justify-between overflow-hidden rounded-md bg-action-primary px-3.5 py-3 text-text-on-action',
        className,
      )}
    >
      <div className="flex min-w-0 flex-col gap-0.5">
        <p className="truncate text-[13px] font-bold">
          {kreditBetCreditorTypeLabel(ticketType, t)}
        </p>
        <p className="truncate text-[11px] opacity-85">
          {t('MaxCredit', { defaultValue: 'Max Kredit' })}
        </p>
      </div>
      <div className="flex min-w-0 flex-col items-end gap-0.5 font-bold">
        <p className="truncate text-[12px]">
          {t('TicketId', { defaultValue: 'Ticket Id' })}: {ticketId}
        </p>
        <p className="tabular-nums text-body-m">
          {withCurrency(formatAmount(maxKredit), currency)}
        </p>
      </div>
    </div>
  );
}
